mainApp.component('maintenancePlanAddEdit', {
    templateUrl: '/public/components/configuration/maintenancePlan/maintenance-plan-add-edit.component.html',
    bindings: {
        currentPhase: '<',
        model: '<',
        errors: '<',
        changeListener: '&',
        accountId: '<',
        isNewPhase: '<',
        socketsStatus: '<'
    },
    controller: maintenancePlanAddEditController
});

function maintenancePlanAddEditController($scope, $rootScope, FieldsService, MaintenanceWindowService, $filter){

    const ctrl = this;

    const POSTPONE_AFTER_CHANGES = "The Maintenance Plan is upgrading Sockets. To change the settings for this plan, save the plan and then click Postpone.";

    ctrl.$onInit = function() {
        ctrl.time = 0;
        ctrl.filters = [];
        ctrl.filterPhaseNames = [];
        ctrl.filterSiteNames = [];
        ctrl.filterSiteTypes = [];
        ctrl.filterLocations = [];
        ctrl.numberOfSelectedSite = [];
        initTimes();
        initFilters();
        ctrl.errors = null;
    }

    ctrl.$onChanges = function(changes){
        setUiTime();
        ctrl.errors = null;
        setNameToCurrentPhaseName()
        setPopUpCloseStr()
    }

    let setNameToCurrentPhaseName = function() {
        ctrl.name = ctrl.currentPhase.name;
    }

    let setPopUpCloseStr = function() {
        let isNewlyCreatePhase = ctrl.currentPhase.id < 0 && !ctrl.currentPhase.name;
    }

    ctrl.closeAndAddPopup = function () {

        if (!ctrl.name || ctrl.currentPhase.name !== ctrl.name){
            isValid();
        }

        if (!ctrl.errors || _.isEmpty(ctrl.errors)){
            setName();
            if (ctrl.isNewPhase){
                ctrl.model.maintenancePhases.push(ctrl.currentPhase);
            }
            $scope.$broadcast('closeAndAdd');
            closeEditor();
        }
    }

    ctrl.closeAndCancelPopup = function () {
        closeEditor();
    }

    ctrl.setTime = function(time, $event){
        $event.stopPropagation();
        ctrl.currentPhase.maintenanceWindow.time = new moment(time, 'HH:mm').format("HH:mm");
    }

    ctrl.setDay = function(day, $event){
        $event.stopPropagation();
        ctrl.currentPhase.maintenanceWindow.day = day;
    }

    ctrl.setWeek = function(week, $event){
        $event.stopPropagation();
        ctrl.currentPhase.maintenanceWindow.week = week;
    }

    let setName = function(){
        ctrl.currentPhase.name = ctrl.name;

        // Object.keys(ctrl.model.phaseNameToIdMap).forEach(key => {
        //     if(ctrl.model.phaseNameToIdMap[key] === ctrl.currentPhase.id){
        //         delete ctrl.model.phaseNameToIdMap[key];
        //     }
        // })

        ctrl.model.phaseNameToIdMap[ctrl.currentPhase.name] = ctrl.currentPhase.id;
    }

    let setUiTime = function(){
        if (!ctrl.isNewPhase && ctrl.currentPhase && ctrl.currentPhase.maintenanceWindow){
            ctrl.time =  parseInt(ctrl.currentPhase.maintenanceWindow.time.replace(":00", ""));
        }else{
            ctrl.time = 0;
        }
    }

    let initTimes = function(){
        const MaintenanceWindow = MaintenanceWindowService.getConsts()

        ctrl.weeks = []
        MaintenanceWindow.WEEKS.forEach(week => ctrl.weeks.push({
            name: week.toString(),
            id: week.toString(),
            field: {
                type: 'Any',
                output: () => {
                    return {'id': week, 'name': 'Any', 'display_name': week};
                }
            }
        }));

        ctrl.days = []
        MaintenanceWindow.DAYS.forEach(day => ctrl.days.push({
            name: $filter('intToDay')(day),
            id: day,
            field: {
                type: 'Any',
                output: () => {
                    return {'id': day, 'name': 'Any', 'display_name': $filter('intToDay')(day)};
                }
            }
        }));

        ctrl.timeSlots = [];
        MaintenanceWindow.TIMESLOTS.forEach(timeSlot => ctrl.timeSlots.push({
            name: $filter('intToTimeSlot')(timeSlot),
            id: timeSlot,
            field: {
                type: 'Any',
                output: () => {
                    return {'id': timeSlot, 'name': 'Any', 'display_name': $filter('intToTimeSlot')(timeSlot)};
                }
            }
        }));


        ctrl.time = (ctrl.currentPhase && ctrl.currentPhase.maintenanceWindow) ? ctrl.currentPhase.maintenanceWindow.time : MaintenanceWindow.DEFUALT_TIME;
    }


    let initFilters = function(){

        ctrl.filterSiteNames = FieldsService.getNewFieldType({
            component: FieldsService.getComponents().comboBox,
            dataURL: () => '/getAllSitesByPhase?accountId=' + ctrl.accountId,
            output: (item) => {
                return item;
            },
        });

        ctrl.filterLocations = FieldsService.getFieldTypes().accountCountries;

        Object.keys(ctrl.model.phaseNameToIdMap).forEach(key => ctrl.filterPhaseNames.push({
            name: $filter('capitalize')(key.toLowerCase()),
            id: ctrl.model.phaseNameToIdMap[key],
            filterType: 'PHASE_NAME',
            field: {
                type: 'Any',
                output: () => {
                    return {'id': ctrl.model.phaseNameToIdMap[key], 'name': 'Any', 'display_name': $filter('capitalize')(key.toLowerCase())};
                }
            }
        }));

        ctrl.siteTypes = ["BRANCH", "HEADQUARTERS", "CLOUD_DC", "DATACENTER"];
        ctrl.siteTypes.forEach(siteType => ctrl.filterSiteTypes.push({
            name: $filter('capitalize')(siteType.toLowerCase()),
            filterType: 'SITE_TYPE',
            id: siteType,
            field: {
                type: 'Any',
                output: () => {
                    return {'id': siteType, 'name': 'Any', 'display_name': $filter('capitalize')(siteType.toLowerCase())};
                }
            }
        }));
    }

    ctrl.setSelectedField = function (name, value, filterType, $event) {
        $event.stopPropagation();
        let filter = {name: name, value: value, filterType: filterType};
        ctrl.filters.push(filter);
        ctrl.filters = angular.copy(ctrl.filters);
    }

    ctrl.removeFilter = function (value) {
        _.remove(ctrl.filters, value);
        ctrl.filters = angular.copy(ctrl.filters);
        $scope.$broadcast('clear-combo', 'filter-value-select');
    }

    let closeEditor = function () {
        ctrl.filters = [];
        $rootScope.closePopup('phaseEditor');
        $scope.$broadcast('clear-combo', 'filter-value-select');
        $scope.$broadcast('clear-combo', 'filter-operator-select');
        ctrl.errors = null;
        if (ctrl.model.planStatus === 'IN_PROGRESS'){
            $rootScope.alert(POSTPONE_AFTER_CHANGES);
        }
    }

    let isValid = function () {
        ctrl.errors = null;

        if (!ctrl.name){
            ctrl.errors = 'Name required';
        }else{
            if (ctrl.currentPhase.isDefault) return;
            let phaseId = ctrl.model.phaseNameToIdMap[ctrl.name.toLowerCase()];
            let oldPhaseIsNotDeleted = phaseId && !ctrl.model.phasesToDelete.filter(id => id === phaseId).length > 0;

            if (phaseId && oldPhaseIsNotDeleted){
                ctrl.errors = 'Duplicate name';
            }
        }
    }

};
